module.exports = __webpack_public_path__ + "static/img/home_7.e29576a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_7.png
// module id = mtrT
// module chunks = 1